import CaseCustomerAndTeam from './CaseCustomerAndTeam'

export default CaseCustomerAndTeam
